export { convertLexicalToPlaintext } from '../../features/converters/lexicalToPlaintext/sync/index.js'

export type {
  PlaintextConverter,
  PlaintextConverters,
} from '../../features/converters/lexicalToPlaintext/sync/types.js'
